import React from 'react'
import { Icon } from 'semantic-ui-react'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import {PrivateComponent} from '../PrivateComponent'

export default class WeekPayment extends React.Component {

    render() {
        return (
            <section>
                <div className='divrowH'>
                    <p>{`Semana ${this.props.week.weekAndYear}`}</p>
                    <p>{`Total: $${this.props.week.total.toFixed(2)}`}</p>
                </div>
                {this.props.week.employees.map((employee, key) => {
                    return <Employee employee={employee} key={key} status={this.props.status} />
                })}
            </section>
        )
    }
}

class Employee extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            tableVisible: false,
        }
    }
    toggleTable = () => {
        this.setState({
            tableVisible: !this.state.tableVisible
        })
    }
    payEmployee = (e) => {
        e.stopPropagation()
        debugger
        const batch = firebase.firestore().batch()
        const payments = firebase.firestore().collection('Pagos')
        const activities = this.props.employee.activities
        const horas = this.props.employee.horas
        const harvestZarzamora = this.props.employee.harvestZarzamora
        const harvestFrambuesa = this.props.employee.harvestFrambuesa
        for (let i = 0; i < activities.length; i++) {
            batch.update(payments.doc(activities[i].id), { estado: 'completado' })
        }
        for (let i = 0; i < horas.length; i++) {
            batch.update(payments.doc(horas[i].id), { estado: 'completado' })
        }
        for (let i = 0; i < harvestZarzamora.length; i++) {
            batch.update(payments.doc(harvestZarzamora[i].id), { estado: 'completado' })
        }
        for (let i = 0; i < harvestFrambuesa.length; i++) {
            batch.update(payments.doc(harvestFrambuesa[i].id), { estado: 'completado' })
        }
        batch.commit().catch(error => {
            console.log(error)
        })
    }
    renderFrambuesaTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h4>Pisca Frambuesa</h4>
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>S/T-S</th>
                            <th>Botes</th>
                            <th>Precio</th>
                            <th>Total</th>
                        </tr>
                        {activities.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.fecha}</td>
                                <td>{activity.areaHecha}</td>
                                <td>{+(activity.trabajoHecho).toFixed(1)}</td>
                                <td>{`$${+(activity.precio / activity.trabajoHecho).toFixed(1)}`}</td>
                                <td>{`$${activity.precio}`}</td>
                            </tr>
                        )}
                    </tbody></table>
                </div>
            </>
        )
    }
    renderZarzamoraTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h4>Pisca Zarzamora</h4>
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>S/T-S</th>
                            <th>Medios Botes</th>
                            <th>Precio</th>
                            <th>Total</th>
                        </tr>
                        {activities.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.fecha}</td>
                                <td>{activity.areaHecha}</td>
                                <td>{+(activity.totalCajas * 4).toFixed(1)}</td>
                                <td>{`$${+(activity.cajas6Precio / 4).toFixed(1)}`}</td>
                                <td>{`$${activity.precio}`}</td>
                            </tr>
                        )}
                    </tbody></table>
                </div>
            </>
        )
    }
    renderHorasTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h4>Sueldo por horas</h4>
                    <table><tbody>
                        <tr>
                            <th>Fecha</th>
                            <th>Puesto1</th>
                            <th>Horas</th>
                            <th>Puesto2</th>
                            <th>Horas</th>
                            <th>Extra</th>
                            <th>Horas</th>
                            <th>Total</th>
                        </tr>
                        {activities.map((activity, key) =>
                            <tr key={key}>
                                <td>{activity.fecha}</td>
                                <td>{activity.puesto1}</td>
                                <td>{activity.horas1}</td>
                                <td>{activity.puesto2}</td>
                                <td>{activity.horas2}</td>
                                <td>{activity.puestoE}</td>
                                <td>{activity.horasE}</td>
                                <td>${(activity.precio).toFixed(2)}</td>
                            </tr>
                        )}
                    </tbody></table>
                </div>
            </>
        )
    }
    renderRoutineTable = (activities) => {
        return (
            <>
                <div className="tabla">
                    <h4>Rutinarias</h4>
                    <table><tbody>
                        <tr>
                            <th>Concepto</th>
                            <th>S/T-S</th>
                            <th>Fecha</th>
                            <th>Cantidad</th>
                            <th>Precio U.</th>
                            <th>Total</th>
                        </tr>

                        {
                            activities.map((activity, i) => {
                                return (
                                    <tr key={i}>
                                        <td>{activity.actividad}</td>
                                        <td>{activity.areaHecha}</td>
                                        <td>{activity.fecha}</td>
                                        <td>{`${Number(activity.trabajoHecho).toFixed(2)} ${activity.unidades || ''}`}</td>
                                        <td>{`${Number(activity.precio / activity.trabajoHecho).toFixed(2)}$`}</td>
                                        <td>{`${activity.precio.toFixed(2)}$`}</td>
                                    </tr>
                                )
                            })
                        }

                    </tbody></table>
                </div>
            </>
        )
    }
    render() {
        return (
            <div className="divtable">
                <div className="divrow" onClick={this.toggleTable}>
                    <p>{`${this.props.employee.employee}`}</p>
                    <p>{`Salario: $${this.props.employee.salary.toFixed(2)}`}</p>
                    {
                        this.props.status === 'unpaid'
                            ? <PrivateComponent roles={['office']}><button onClick={this.payEmployee}><Icon name='dollar' /> Pagar</button></PrivateComponent>
                            : null
                    }
                </div>
                {
                    this.state.tableVisible
                        ? this.props.employee.activities.length > 0
                            ? this.renderRoutineTable(this.props.employee.activities)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.employee.horas.length > 0
                            ? this.renderHorasTable(this.props.employee.horas)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.employee.harvestFrambuesa.length > 0
                            ? this.renderFrambuesaTable(this.props.employee.harvestFrambuesa)
                            : null
                        : null
                }
                {
                    this.state.tableVisible
                        ? this.props.employee.harvestZarzamora.length > 0
                            ? this.renderZarzamoraTable(this.props.employee.harvestZarzamora)
                            : null
                        : null
                }
            </div>
        )
    }
}